import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type SignInMethod = 'passkey' | 'google'

type AuthPreferenceState = {
  /** この端末で最後に使った（または使えるようにした）サインイン方法。サインアウトしても残す */
  lastSignInMethod: SignInMethod | null
  /** Google でサインインした後のパスキー登録の案内を、この端末で出したか */
  passkeyPromptShown: boolean
  setLastSignInMethod: (method: SignInMethod) => void
  markPasskeyPromptShown: () => void
}

/** サインイン方法に関する端末ごとの設定（localStorage に保存） */
export const useAuthPreferenceStore = create<AuthPreferenceState>()(
  persist(
    (set) => ({
      lastSignInMethod: null,
      passkeyPromptShown: false,
      setLastSignInMethod: (method) => set({ lastSignInMethod: method }),
      markPasskeyPromptShown: () => set({ passkeyPromptShown: true }),
    }),
    { name: 'auth-preference' },
  ),
)
